/**
 * Irrigation System Monitoring - Module Exports
 * Main entry point for the Irrigation System Monitoring feature
 */

// Main Component
const IrrigationSystemMonitoring = require('./IrrigationSystemMonitoring.jsx');

// Sub-components (exported for testing and advanced usage)
const FarmViewMap = require('./FarmViewMap.jsx');
const FieldListTable = require('./FieldListTable.jsx');
const IrrigationActivityIndicator = require('./IrrigationActivityIndicator.jsx');
const WeeklyPerformanceBar = require('./WeeklyPerformanceBar.jsx');
const StressGauge = require('./StressGauge.jsx');
const RootZoneWP = require('./RootZoneWP.jsx');
const RecommendationDisplay = require('./RecommendationDisplay.jsx');
const OnboardingBanner = require('./OnboardingBanner.jsx');

// Hooks
const useIrrigationMonitoring = require('./useIrrigationMonitoring.jsx');
const useIrrigationPersistence = require('./useIrrigationPersistence.jsx');
const useAllFarmViewData = require('./useAllFarmViewData.jsx');

// Types and utilities
const types = require('./types.js');

// Export as default
module.exports = IrrigationSystemMonitoring;

// Named exports for advanced usage
module.exports.IrrigationSystemMonitoring = IrrigationSystemMonitoring;
module.exports.FarmViewMap = FarmViewMap;
module.exports.FieldListTable = FieldListTable;
module.exports.IrrigationActivityIndicator = IrrigationActivityIndicator;
module.exports.WeeklyPerformanceBar = WeeklyPerformanceBar;
module.exports.StressGauge = StressGauge;
module.exports.RootZoneWP = RootZoneWP;
module.exports.RecommendationDisplay = RecommendationDisplay;
module.exports.OnboardingBanner = OnboardingBanner;
module.exports.useIrrigationMonitoring = useIrrigationMonitoring;
module.exports.useIrrigationPersistence = useIrrigationPersistence;
module.exports.useAllFarmViewData = useAllFarmViewData;
module.exports.types = types;
